import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../ui/accordion';

const FAQS = [
  {
    q: '¿Puedo cambiar de plan cuando quiera?',
    a: 'Sí. Puedes subir o bajar de plan cuando lo necesites desde tu panel de facturación; el cambio se prorratea automáticamente.',
  },
  {
    q: '¿Hay coste de instalación o permanencia?',
    a: 'No. Sin coste de instalación oculto y sin permanencia — puedes cancelar cuando quieras.',
  },
  {
    q: '¿Qué pasa si supero el límite de búsquedas con IA de mi plan?',
    a: 'Tu buscador nunca se bloquea: si superas el límite mensual de búsquedas con IA, el motor clásico sigue funcionando sin interrupciones hasta el mes siguiente.',
  },
  {
    q: '¿Los precios incluyen IVA?',
    a: 'No, los precios mostrados no incluyen IVA. Se calcula automáticamente según el país de tu negocio en el momento del pago.',
  },
  {
    q: '¿Qué plan me conviene si tengo varias tiendas?',
    a: 'Depende de tu volumen y necesidades — solicita una demo y te ayudamos a elegir el plan (o combinación) adecuado.',
  },
];

export function PricingFAQ() {
  return (
    <section id="faq" data-testid="pricing-faq-section" className="py-16 md:py-24 px-6 max-w-3xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-black tracking-tighter text-white text-center mb-12">
        Preguntas frecuentes sobre precios
      </h2>

      <Accordion type="single" collapsible data-testid="pricing-faq-accordion" className="w-full">
        {FAQS.map((item, i) => (
          <AccordionItem key={i} value={`pricing-faq-${i}`} data-testid={`pricing-faq-item-${i}`} className="border-white/10">
            <AccordionTrigger className="text-white text-base hover:no-underline">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-zinc-400 leading-relaxed">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
